import { Page } from "@/components/Page";
import { PageHero } from "@/components/PageHero";
import { ServiceList } from "@/components/ServiceList";
import { WhyChoose } from "@/components/WhyChoose";
import { AppointmentSection } from "@/components/AppointmentSection";
import { SPEECH_SERVICES, CLINIC_PHOTOS } from "@/data/site";

export default function SpeechHearing() {
  return (
    <Page>
      <PageHero
        crumb="Speech & Hearing"
        overline="Speech, Language & Hearing Care"
        title={"Speech, Language &\nHearing Care"}
        subtitle="Supporting better communication and hearing through personalized assessment and professional care."
        image={CLINIC_PHOTOS.hearingCare}
      />
      <ServiceList
        overline="Our Services"
        title="Speech, Language & Hearing Services"
        subtitle="Individualized assessment and therapy for children and adults, focused on supporting communication and hearing in everyday life."
        services={SPEECH_SERVICES}
        ctaLabel="Book a Speech & Hearing Appointment"
        accent="indigo"
      />
      <WhyChoose />
      <AppointmentSection />
    </Page>
  );
}
